import { Type } from "@sinclair/typebox";
import { TypeBoxToType } from "../TypeBoxToType";

export const CONVERSATION_STATUS = {
  OPEN: "OPEN",
  PENDING: "PENDING",
  BOT: "BOT",
  CLOSED: "CLOSED",
} as const;

export const ConversationStatus = Type.Union([
  Type.Literal(CONVERSATION_STATUS.OPEN),
  Type.Literal(CONVERSATION_STATUS.PENDING),
  Type.Literal(CONVERSATION_STATUS.BOT),
  Type.Literal(CONVERSATION_STATUS.CLOSED),
]);
export type ConversationStatus = TypeBoxToType<typeof ConversationStatus>;

export const ASSIGNMENT_FILTER = {
  ALL: "all",
  UNASSIGNED: "unassigned",
  ASSIGNED_TO_ME: "assigned_to_me",
} as const;

export const AssignmentFilter = Type.Union([
  Type.Literal(ASSIGNMENT_FILTER.ALL),
  Type.Literal(ASSIGNMENT_FILTER.UNASSIGNED),
  Type.Literal(ASSIGNMENT_FILTER.ASSIGNED_TO_ME),
]);
export type AssignmentFilter = TypeBoxToType<typeof AssignmentFilter>;

export const AssignableAgent = Type.Object({
  _id: Type.String(),
  userId: Type.String(),
  firstName: Type.Optional(Type.String()),
  lastName: Type.Optional(Type.String()),
  email: Type.Optional(Type.String()),
});
export type AssignableAgent = TypeBoxToType<typeof AssignableAgent>;

export function getAgentDisplayName(agent: AssignableAgent): string {
  if (agent.firstName || agent.lastName) {
    return `${agent.firstName ?? ""} ${agent.lastName ?? ""}`.trim();
  }
  return agent.email ?? agent.userId ?? "";
}

export const ConversationManagementOptions = Type.Object({
  assignConversationToMe: Type.Optional(Type.Boolean()),
  assignToUserId: Type.Optional(Type.String()),
  setConversationToOpen: Type.Optional(Type.Boolean()),
});
export type ConversationManagementOptions = TypeBoxToType<typeof ConversationManagementOptions>;

export const ImConversation = Type.Object({
  _id: Type.String(),
  orgId: Type.String(),
  chatId: Type.String(),
  phoneId: Type.String(),
  phone: Type.Number(),
  status: ConversationStatus,
  closedAt: Type.Optional(Type.Date()),
  closedBy: Type.Optional(Type.String()),
  lastMessageAt: Type.Optional(Type.Date()),
  assignedAgentIds: Type.Optional(Type.Array(Type.String())),
  createdAt: Type.String(),
  updatedAt: Type.String(),
});
export type ImConversation = TypeBoxToType<typeof ImConversation>;
